import { createRouter, createWebHistory } from 'vue-router'
import { appRoutes } from './modules'
import setupPermissionGuard from './permission'
import MultipleEndLayout from '@/layout/MultipleEndLayout.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则恢复到该位置
    if (savedPosition) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 66)
      })
    }
    // 否则滚动到页面顶部
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      component: MultipleEndLayout,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/home/index.vue'),
          meta: {
            title: 'U课AI',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'course',
          name: 'course',
          component: () => import('@/views/course/course.vue'),
          meta: {
            title: '我的课程',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'course_info',
          name: 'course_info',
          component: () => import('@/views/course/course_info.vue'),
          meta: {
            title: '课程详情',
            selfHeader: true
          },
        },
        {
          path: 'course/knowledge',
          name: 'courseKnowledge',
          component: () => import('@/views/course/knowledge/index.vue'),
          meta: {
            title: '知识点',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'knowledge',
          name: 'knowledge',
          component: () => import('@/views/knowledge/index.vue'),
          meta: {
            title: '知识点',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'agent-list',
          name: 'agentList',
          component: () => import('@/views/course/agent-list/index.vue'),
          meta: {
            title: '智能体',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'chat',
          name: 'chat',
          component: () => import('@/views/chat/chat.vue'),
          meta: {
            title: '助教',
            ignoreCache: true,
            selfHeader: true,
            reuse: true
          },
        },
        {
          path: 'user',
          name: 'user',
          component: () => import('@/views/user/user.vue'),
          meta: {
            title: '我的',
            ignoreCache: true,
            selfHeader: true
          },
        },
        {
          path: 'learning-center',
          name: 'learningCenter',
          component: () => import('@/views/learning-center/index.vue'),
          meta: {
            navTitle: 'agentSquare.learningCenter',
            title: '学习中心',
            selfHeader: true,
            ignoreCache: true
          },
        },
        {
          path: 'learning-center/detail',
          name: 'learningCenterDetail',
          component: () => import('@/views/learning-center/detail.vue'),
          meta: {
            navTitle: 'agentSquare.sessionDetail',
            title: '课堂详情',
            ignoreCache: true
          },
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        title: '登录',
        requiresAuth: false,
        ignoreCache: true,
        selfHeader: true
      }
    },
    {
      path: '/user-agreement',
      name: 'user-agreement',
      component: () => import('@/views/agreement/user-agreement.vue'),
      meta: {
        title: '用户协议',
        requiresAuth: false,
        ignoreCache: true,
        selfHeader: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/views/agreement/privacy-policy.vue'),
      meta: {
        title: '隐私政策',
        requiresAuth: false,
        ignoreCache: true
      }
    },
    {
      path: '/bridge',
      name: 'bridge',
      component: () => import('@/views/bridge/index.vue'),
      meta: {
        title: '正在跳转',
        requiresAuth: false,
        ignoreCache: true
      }
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: () => import('@/views/errors/notFound.vue'),
      meta: {
        title: '404',
        requiresAuth: false,
        ignoreCache: true
      }
    },
    ...appRoutes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/not-found',
    },
  ],
})

setupPermissionGuard(router)


export default router
